type CapacitorGlobal = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
};

function readCapacitor(): CapacitorGlobal | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const cap = (window as Window & { Capacitor?: CapacitorGlobal }).Capacitor;
  return cap ?? null;
}

/** True when running inside a Capacitor native shell (Android/iOS), not a normal browser tab. */
export function isCapacitorNative(): boolean {
  return Boolean(readCapacitor()?.isNativePlatform?.());
}

export function capacitorPlatform(): string {
  return readCapacitor()?.getPlatform?.() ?? 'web';
}
